import { useMutation } from '@tanstack/react-query'

import { updateSiteContact } from '@/features/site/endpoints/sites'
import type { SiteContact } from '@/features/site/types/site'

export type UseUpdateSiteContactMutationResult = ReturnType<typeof useUpdateSiteContactMutation>

export function useUpdateSiteContactMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { siteUuid: string; location: string; contact: SiteContact }) =>
      updateSiteContact({ siteUuid: variables.siteUuid, location: variables.location, contact: variables.contact }),
  })

  return {
    updateSiteContact: mutateAsync,
    ...mutationResult,
  }
}
